/**
 * search-synonyms.js
 * Expand a query with semantic equivalents to improve recall.
 * Add new entries here as the app's vocabulary grows.
 */

import { normalizeText } from "./search-rank";

// Map: normalized Spanish term → related terms (Spanish and status values)
const SYNONYM_MAP = {
  // Visit status
  activa:      ["pendiente", "activo"],
  pendiente:   ["activa", "activo", "sin completar"],
  completada:  ["terminada", "hecha", "completado"],
  urgente:     ["urgente", "critica", "critico"],
  // Pastoral roles
  pastor:      ["predicador", "ministro", "lider", "director"],
  predicador:  ["pastor", "ministro"],
  // Oración / prayer
  oracion:     ["peticion", "intercesion", "ruego", "prayer"],
  peticion:    ["oracion", "intercesion", "ruego"],
  intercesion: ["oracion", "peticion", "ruego"],
  ruego:       ["oracion", "peticion", "intercesion"],
  // Iglesia
  iglesia:     ["church", "congregacion", "templo", "comunidad", "local"],
  templo:      ["iglesia", "congregacion", "comunidad"],
  congregacion:["iglesia", "templo", "comunidad"],
  // Familia
  familia:     ["family", "hogar", "casa", "nucleo"],
  hogar:       ["familia", "casa"],
  casa:        ["familia", "hogar"],
  // Visita
  visita:      ["visit", "seguimiento", "pastoral", "visitation"],
  pastoral:    ["visita", "seguimiento"],
  // Persona
  persona:     ["person", "miembro", "hermano", "feliges"],
  miembro:     ["persona", "hermano", "feliges"],
  hermano:     ["persona", "miembro"],
  // Bautismo
  bautismo:    ["inmersion", "bautizado", "baptism"],
  inmersion:   ["bautismo", "bautizado"],
  bautizado:   ["bautismo", "inmersion"],
  // Predicación
  predicacion: ["sermon", "mensaje", "predica", "exposicion"],
  sermon:      ["predicacion", "mensaje", "predica"],
  mensaje:     ["predicacion", "sermon", "predica"],
  predica:     ["predicacion", "sermon", "mensaje"],
  exposicion:  ["predicacion", "sermon"],
  // Nota
  nota:        ["apunte", "recordatorio", "memoria"],
  apunte:      ["nota", "recordatorio"],
  recordatorio:["nota", "apunte"],
  // Agenda / eventos
  agenda:      ["evento", "actividad", "calendario"],
  evento:      ["agenda", "actividad", "reunion", "culto", "calendario"],
  actividad:   ["agenda", "evento", "reunion"],
  calendario:  ["agenda", "evento"],
};

/**
 * Returns an array of search terms: [originalQuery, ...synonyms].
 * The original query is always first to preserve ranking priority.
 * Deduplicates terms automatically.
 */
export function expandQuery(query) {
  const q = normalizeText(query);
  if (!q) return [query];

  const extra = new Set();
  for (const [key, values] of Object.entries(SYNONYM_MAP)) {
    if (q === key || q.includes(key) || key.includes(q)) {
      values.forEach((v) => extra.add(v));
    }
  }
  // Remove original term from extras to avoid duplicates
  extra.delete(q);

  return [query, ...Array.from(extra)];
}
